export default {
  template: '#vue-product-carousel',
  delimiters: ['${', '}'],
  props: ['collection_handle', 'collection_id', 'recommended_id', 'product_ids', 'heading_text', 'description_text', 'limit', 'type'],
  computed: {},
  data() {
    return {
      products: [],
      scroll_pos: 0
    }
  },
  methods: {
    carouselImpressionClick(product) {
      dataLayer.push({ecommerce: null});
      dataLayer.push({
        'event': 'select_item',
        'ecommerce': {
          'items': [window.impressions[product.index]]
        }
      });
    }
  },
  mounted() {
    this.$store.dispatch('getLocation').then(
        resp => {
          let query = {type_: this.type}
          if (this.type === 'related') {
            query.recommended_id = this.recommended_id
            query.collection_id = this.collection_id
          } else if (this.type === 'collection') {
            query.collection_id = this.collection_id
          } else if (this.type === 'like') {
            query.recommended_id = this.recommended_id
          } else if (this.type === 'products') {
            query.product_ids = this.product_ids.replace(/\s/g, '')
          }
          if (this.limit) {
            query.limit = this.limit
          }
          this.$store.dispatch("getCarouselItems", query).then(
              products => {
                this.products = products
              },
              () => {
              }
          )
        },
        () => {
        })
  }
}